<template>
	<div v-if="!is_logged_in">
		<div class="not_logged_in" v-if="!is_logged_in">
			<button
				class="button_bg_red mr_5"
				v-on:click="$router.push({ name: 'auth-login' })"
			>
				{{ $t('auth.login_btn') }}
			</button>
			<button
				class="button_border_red"
				v-on:click="$router.push({ name: 'auth-register' })"
			>
				{{ $t('auth.signup_btn') }}
			</button>
		</div>
		<div class="logged_in" v-if="is_logged_in"></div>
	</div>
</template>

<script>
export default {
	el: '#menu_auth',
	name: 'menu-auth',
	props: {
		is_logged_in: Boolean,
	},
	data: function () {
		return {
			show1: false,
			show2: false,
		};
	},
	methods: {},
};
</script>
